import { MiaPlaza } from "../../../../Reinforced.Typings";

import AjaxHelpers = MiaPlaza.Control.Vue.Stores.Shared.AjaxHelpers;
import { makeConversionProvider, type ConversionProvider } from "../../Stores/VueList/ConversionStore";

/**
 * Convenience class for getting often used urls for vue lists.
 */
export default class VueListUrlHelper {
	public static GetConversionUrl(converter: (parameter: MiaPlaza.IPlaceholder) => string): string {
		return AjaxHelpers.GetConvertAsyncUrl(
			{ Placeholder: AjaxHelpers.PLACEHOLDER_CONVERT_MANY },
			converter({ Placeholder: AjaxHelpers.PLACEHOLDER_CONVERT_ONE }));
	}

	public static GetBatchConversionProvider<S, T>(converter: (parameter: MiaPlaza.IPlaceholder) => string): ConversionProvider<S, T> {
		return makeConversionProvider(converter({ Placeholder: AjaxHelpers.PLACEHOLDER_CONVERT_MANY }));
	}

	public static GetDataUrl(dataUrl: string): string {
		return AjaxHelpers.GetRangeAsyncUrl(dataUrl,
			{ Placeholder: AjaxHelpers.PLACEHOLDER_OFFSET },
			{ Placeholder: AjaxHelpers.PLACEHOLDER_LIMIT });
	}
}
